import "./myAccount.scss";
import Navbar from "../../components/navbar/Navbar";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Avatar,
} from "@mui/material";
import {
  Person,
  AccountBalance,
  TrendingUp,
  School,
  LocationOn,
  Phone,
  Edit,
  Save,
  Info,
} from "@mui/icons-material";
import { handleInputNumber } from "../../context/commonFunctions";
import { generateKeywords } from "../../functions";
import { useUserData } from "../../context/UserContext";
import WalletList from "./walletList";
import InfoIcon from "@mui/icons-material/Info";

function MyAccount() {
  const { userData } = useUserData();
  const [openLoading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [controlChips, setControlChips] = useState({
    l: "default",
    f: "default",
  });
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong.\nPlease try again"
  );
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    experience: 0,
    booksWritten: 0,
    currentInstitute: "",
    city: "",
    pincode: 0,
    department: "",
  });
  const [formErrors, setFormErrors] = useState({
    fullName: "",
    phoneNumber: "",
    experience: "",
    booksWritten: "",
    currentInstitute: "",
    city: "",
    pincode: "",
    department: "",
  });
  useEffect(async () => {
    document.title = "My Account";
  }, []);

  useEffect(() => {
    try {
      if (userData) {
        if (userData.controlAccess === "limited") {
          setControlChips({ l: "primary", f: "default" });
        } else {
          setControlChips({ l: "default", f: "primary" });
        }

        setFormData({
          fullName: userData.fullName,
          phoneNumber: userData.phoneNumber,
          experience: userData.experience,
          booksWritten: userData.booksWritten,
          currentInstitute: userData.currentInstitute,
          city: userData.city,
          pincode: userData.pincode,
          department: userData.department,
        });

        setDataAvailable(true);
        setInitialLoading(false);
      } else {
        setInitialLoading(false);
        setErrorMessage("There is no such user available. Please try again.");
      }
    } catch (error) {
      setInitialLoading(false);
      setErrorMessage("Error - " + error);
    }
  }, [userData]);

  const validateForm = () => {
    const errors = {
      fullName: "",
      phoneNumber: "",
      experience: "",
      booksWritten: "",
      currentInstitute: "",
      city: "",
      pincode: "",
      department: "",
    };

    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Name cannot be empty";
      isValid = false;
    }
    if (!formData.phoneNumber.trim() || formData.phoneNumber.length < 10) {
      errors.phoneNumber = "Invalid Phone number";
      isValid = false;
    }
    if (!formData.experience) {
      errors.experience = "Experience cannot be empty";
      isValid = false;
    }

    if (!formData.booksWritten) {
      errors.booksWritten = "No. of books written cannot be empty/zero";
      isValid = false;
    }
    if (!formData.currentInstitute.trim()) {
      errors.currentInstitute = "Institute name cannot be empty";
      isValid = false;
    }
    if (!formData.city.trim()) {
      errors.city = "City cannot be empty";
      isValid = false;
    }
    if (!formData.department.trim()) {
      errors.department = "Department cannot be empty";
      isValid = false;
    }
    if (!formData.pincode || formData.pincode === 0) {
      errors.pincode = "Pincode cannot be empty/zero";
      isValid = false;
    }
    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);
      try {
        var mapData = formData;
        mapData = {
          ...mapData,
          searchKeywords: generateKeywords(formData.fullName),
        };
        const publisherID = localStorage.getItem("publisherID");

        const publisherRef = doc(db, "publishers", publisherID);
        await updateDoc(publisherRef, mapData);
        setLoading(false);
        alert("Updated Successfully");
      } catch (error) {
        setLoading(false);
        alert("Error updating account: " + error);
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="myAccount">
        <Container maxWidth="xl" sx={{ py: 3 }}>
          {initialLoading && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
            >
              <CircularProgress size={60} />
            </Box>
          )}
          
          {!initialLoading && !isDataAvailable && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
            >
              <Typography variant="h6" color="error">
                {errorMessage}
              </Typography>
            </Box>
          )}
          
          {!initialLoading && isDataAvailable && (
            <>
              {/* Header */}
<Card elevation={3} sx={{ mb: 4, borderRadius: 2, overflow: 'hidden' }}>
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(to right, #3f51b5, #2196f3)',
                  color: 'white'
                }}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Avatar 
                        sx={{ 
                          width: 70, 
                          height: 70, 
                          bgcolor: 'rgba(255,255,255,0.2)',
                          border: '2px solid white'
                        }}
                      >
                        <Person fontSize="large" />
                      </Avatar>
                    </Grid>
                    <Grid item xs>
                      <Typography variant="h4" component="h1" fontWeight="bold">
                        My Account
                      </Typography>
                      <Typography variant="subtitle1" sx={{ opacity: 0.9, mt: 0.5 }}>
                        Welcome back, {userData.fullName}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: 1,
                        bgcolor: 'rgba(255,255,255,0.1)', 
                        p: 1.5, 
                        borderRadius: 2
                      }}>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                          Access Level:
                        </Typography>
                        <Stack direction="row" spacing={1}>
                          <Chip
                            color={controlChips.l === 'primary' ? 'default' : 'default'}
                            label="Limited Access"
                            size="small"
                            sx={{
                              bgcolor: controlChips.l === 'primary' ? 'white' : 'rgba(255,255,255,0.3)',
                              color: controlChips.l === 'primary' ? 'primary.main' : 'white',
                              fontWeight: controlChips.l === 'primary' ? 'bold' : 'normal'
                            }}
                          />
                          <Chip
                            color={controlChips.f === 'primary' ? 'default' : 'default'}
                            label="Full Access"
                            size="small"
                            sx={{
                              bgcolor: controlChips.f === 'primary' ? 'white' : 'rgba(255,255,255,0.3)',
                              color: controlChips.f === 'primary' ? 'primary.main' : 'white',
                              fontWeight: controlChips.f === 'primary' ? 'bold' : 'normal'
                            }}
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Card>

              <Grid container spacing={3}>
                {/* Statistics & Wallet - Show first on mobile */}
                <Grid item xs={12} lg={4} sx={{ order: { xs: 1, lg: 2 } }}>
                  <Stack spacing={3}>
                    {/* Sales Statistics */}
                    <Card elevation={2}>
                      <CardHeader
                        title={
                          <Box display="flex" alignItems="center" gap={1}>
                            <TrendingUp color="primary" />
                            <Typography variant="h6">Sales Overview</Typography>
                          </Box>
                        }
                      />
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={4} lg={12}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="h4" color="primary" gutterBottom>
                                ₹{userData.totalSale}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Total Sales
                              </Typography>
                            </Paper>
                          </Grid>
                          <Grid item xs={12} sm={4} lg={12}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="h4" color="secondary" gutterBottom>
                                {userData.unitSold}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Units Sold
                              </Typography>
                            </Paper>
                          </Grid>
                          <Grid item xs={12} sm={4} lg={12}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                              <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                <Typography variant="h4" color="success.main" gutterBottom>
                                  ₹{((userData.totalSale / 100) * userData.commission).toFixed(2)}
                                </Typography>
                                <Tooltip title="This is an approximate commission earned as commission rate may vary from time to time">
                                  <Info fontSize="small" color="action" />
                                </Tooltip>
                              </Box>
                              <Typography variant="body2" color="text.secondary">
                                Commission Earned ({userData.commission}%)
                              </Typography>
                            </Paper>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    {/* Wallet */}
                    <Card elevation={2}>
                      <CardHeader
                        title={
                          <Box display="flex" alignItems="center" gap={1}>
                            <AccountBalance color="primary" />
                            <Typography variant="h6">Wallet</Typography>
                          </Box>
                        }
                      />
                      <CardContent>
                        <Box textAlign="center" mb={2}>
                          <Typography variant="h3" color="primary" gutterBottom>
                            ₹{userData.walletBalance}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Available Balance
                          </Typography>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Box display="flex" justifyContent="center">
                          <WalletList
                            publisherId={localStorage.getItem("publisherID")}
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Stack>
                </Grid>

                {/* Personal Information - Show second on mobile */}
                <Grid item xs={12} lg={8} sx={{ order: { xs: 2, lg: 1 } }}>
                  <Card elevation={2}>
                    <CardHeader
                      title={
                        <Box display="flex" alignItems="center" gap={1}>
                          <Edit color="primary" />
                          <Typography variant="h6">Personal Information</Typography>
                        </Box>
                      }
                      subheader="Update your personal and professional details"
                    />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Full Name"
                            defaultValue={userData.fullName}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fullName: e.target.value,
                              });
                            }}
                            error={formErrors.fullName !== ""}
                            helperText={formErrors.fullName}
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Person color="action" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Phone Number"
                            onInput={handleInputNumber}
                            defaultValue={userData.phoneNumber}
                            inputProps={{ maxLength: 10 }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Phone color="action" />
                                  +91
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                phoneNumber: e.target.value,
                              });
                            }}
                            error={formErrors.phoneNumber !== ""}
                            helperText={formErrors.phoneNumber}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Teaching Experience"
                            inputProps={{ maxLength: 2 }}
                            defaultValue={
                              new Date().getFullYear() - userData.experience
                            }
                            onInput={handleInputNumber}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <School color="action" />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">years</InputAdornment>
                              ),
                            }}
                            onChange={(e) => {
                              const currentYear = new Date().getFullYear();
                              setFormData({
                                ...formData,
                                experience:
                                  currentYear - (parseInt(e.target.value, 10) || 0),
                              });
                            }}
                            error={formErrors.experience !== ""}
                            helperText={formErrors.experience}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            onInput={handleInputNumber}
                            inputProps={{ maxLength: 4 }}
                            defaultValue={userData.booksWritten}
                            label="No. of Books Written"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                booksWritten: e.target.value,
                              });
                            }}
                            error={formErrors.booksWritten !== ""}
                            helperText={formErrors.booksWritten}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Current College or Institution Name"
                            defaultValue={userData.currentInstitute}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                currentInstitute: e.target.value,
                              });
                            }}
                            error={formErrors.currentInstitute !== ""}
                            helperText={formErrors.currentInstitute}
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <School color="action" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="City of Residence"
                            defaultValue={userData.city}
                            onChange={(e) => {
                              setFormData({ ...formData, city: e.target.value });
                            }}
                            error={formErrors.city !== ""}
                            helperText={formErrors.city}
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <LocationOn color="action" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            onInput={handleInputNumber}
                            defaultValue={userData.pincode}
                            inputProps={{ maxLength: 6 }}
                            label="Pincode"
                            onChange={(e) => {
                              setFormData({ ...formData, pincode: e.target.value });
                            }}
                            error={formErrors.pincode !== ""}
                            helperText={formErrors.pincode}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            defaultValue={userData.department}
                            label="Academic Department"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                department: e.target.value,
                              });
                            }}
                            error={formErrors.department !== ""}
                            helperText={formErrors.department}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      <Box mt={3} display="flex" justifyContent="flex-end">
                        <Button
                          variant="contained"
                          startIcon={<Save />}
                          onClick={handleSubmit}
                          size="large"
                          sx={{ minWidth: 150 }}
                        >
                          Update Profile
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>
            </>
          )}
        </Container>
          </div>
   
      
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={openLoading}
      >
        <Card sx={{ p: 3, textAlign: 'center', minWidth: 300 }}>
          <CircularProgress
            size={60}
            sx={{ mb: 2 }}
          />
          <Typography variant="h6" gutterBottom>
            Updating Profile...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we save your changes
          </Typography>
        </Card>
      </Backdrop>
    </>
  );
}

export default MyAccount;
